/*
* Image Magnify function on PDP
*
**/

custom.pdpMagnifier = (() => {

  const className = 'js-pdp-magnifier';
  const fullscreenClassName = 'js-pdp-magnifier-fullscreen';

  function openMagnifier(event=null) {
    $('body').addClass(fullscreenClassName);
    if(event.currentTarget && $(event.currentTarget).length) {
      const $targetImage = $(event.currentTarget);
      if($targetImage.hasClass('is-image')) {
        setTimeout(() => {
          $targetImage[0].scrollIntoView({behavior: "smooth", block: "start", container: "nearest"});
        }, 250);
      }
    }
    return true;
  }

  function closeMagnifier(event=null) {
    if(!$(event.currentTarget).hasClass(className) && !$('body').hasClass(fullscreenClassName)) return;
    if(event.currentTarget && $(event.currentTarget).length) {
      const $targetImage = $(event.currentTarget);
      if($targetImage.hasClass('is-image')) {
        setTimeout(() => {
          $targetImage[0].scrollIntoView({behavior: "smooth", block: "center", container: "nearest"});
        }, 250);
      }
    } 
    return $('body').removeClass(fullscreenClassName);
  }

  function toggleMagnifier(event=null) {
    event.stopPropagation();
    return ($('body').hasClass(fullscreenClassName))? closeMagnifier(event) : openMagnifier(event);
  }

  function closeMagnifierOutside(event=null) {
    if (!event.target.classList.contains(className) && !event.target.hasAttribute("data-product-image-id")) {
      $('body').hasClass(fullscreenClassName) ? $('body').removeClass(fullscreenClassName) : null;
    }
  }

  let init = () => {
    if($(`.${className}`)) {
      $(`body`).on('click', closeMagnifierOutside);
      $(`.${className}`).on('click', toggleMagnifier);
    }
  }

  return {
    init
  }
})();

custom.pdpMagnifier.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/pdp-magnifier.js